import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';

export const ordersDriverObj = (dispatch) => {
  const steps = [
    {
      element: '.exportOrders',
      popover: {
        title: 'Export Orders',
        description: 'Export order data to CSV format for tracking and analysis.',
        side: 'left',
        align: 'start',
      },
    },
    {
      element: '.orderFiltersToggleButton',
      popover: {
        title: 'Filters Toggle Button',
        description: 'Click here to toggle the filter menu to filter orders.',
        side: 'left',
        align: 'start',
      },
    },
    {
      element: '.createOrder',
      popover: {
        title: 'Create Order',
        description: 'Create new purchase orders for inventory items.',
        side: 'left',
        align: 'start',
      },
    },
    {
      element: '.orderFilters',
      popover: {
        title: 'Filter Orders',
        description: 'Filter orders by status, date, supplier or other criteria.',
        side: 'left',
        align: 'start',
      },
    },
    {
      element: '.orderTable',
      popover: {
        title: 'Orders Overview',
        description: 'View all your orders in this table.',
        side: 'left',
        align: 'start',
      },
    },
    {
      element: '.orderActions',
      popover: {
        title: 'Order Actions',
        description: 'You can edit and delete orders.',
        side: 'left',
        align: 'start',
      },
    },
  ].filter((step) => document.querySelector(step.element) !== null);

  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps,
  });
  return driverObj;
};

export default ordersDriverObj;
